import React from 'react';
import { Menu } from 'lucide-react';
import { getCurrentUser } from '../utils/auth';
import NotificationBell from './Notifications/NotificationBell';
import BranchSelector from './Common/BranchSelector';
import { usePageTitle } from '../contexts/PageTitleContext';

const ROLE_LABELS = {
  tenantadmin: 'Platform Admin',
  superadmin: 'Super Admin',
  admin: 'Admin',
  instructor: 'Instructor',
  student: 'Student',
};

const TopNav = ({ onMenuClick }) => {
  const user = getCurrentUser();
  const userInitials = user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'SA';
  const roleLabel = ROLE_LABELS[user?.usertype] || user?.usertype || 'User';
  const { pageTitle } = usePageTitle();

  return (
    <header className="top-nav-header">
      <div className="top-nav-content">
        <div className="top-nav-left">
          <button className="nav-action-btn d-md-none" onClick={onMenuClick} aria-label="Open menu">
            <Menu size={20} />
          </button>
          {pageTitle && <span className="top-nav-page-title d-md-none">{pageTitle}</span>}
        </div>
        <div className="top-nav-right">
          <div id="top-nav-portal" className="top-nav-portal"></div>
          <BranchSelector />
          <NotificationBell />
          <div className="user-profile-section d-none d-md-flex">
            <div className="user-avatar">{userInitials}</div>
            <div className="user-details">
              <div className="user-name">{user?.name || 'User'}</div>
              <div className="user-role">{roleLabel}</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopNav;
